/* This is a function  that receives as arguments the index of the selectedProject and the name
of the edited dataElement and returns the index of the data element that belongs to the selected Project
*/
function findIndexDataElement(selectedProject, dataElementName) {
  let indexDataEl = -1;
  const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].data_elements
    .data_elements_info;
  tempData.forEach((data_element, index) => {
    if (data_element.dataName === dataElementName) {
      indexDataEl = index;
    }
  });
  return indexDataEl;
}

function findId(selectedProject, pageName) {
  let id = -1;

  const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
  tempData.forEach((page) => {
    if (page.name === pageName) {
      id = page.pageId;
    }
  });

  return id;
}

// This is a function that generates a new block based on an edited data element that is type form
function extractContent(
  editor,
  selectedProject,
  dataElementName,
  producedBlockName,
  componentsInfo
) {
  if (editor.BlockManager !== undefined) {
    const tempComponents = []; // In this var will be stored all the info of the components of the edited form that will be used to produce the block

    // Parse every line of the edited form
    componentsInfo.forEach((row, index) => {
      tempComponents.push({ components: [] ,classes: ['flex'] });
      // Check for every component inside a div of form
      row.div.forEach((insideComp, index2) => {
        // Check for component type button
        if (insideComp === 'button') {
          const {label} = componentsInfo[index].info[index2];
          const {method} = componentsInfo[index].info[index2];

          const {href} = componentsInfo[index].info[index2];
          const targetPageName = componentsInfo[index].info[index2].target_page;
          const target_page = findId(selectedProject, targetPageName);

          const tempAttributes = {};
          if (target_page !== undefined && target_page !== '' && target_page !== 'undefined') {
            tempAttributes.target_page = target_page;
          }
          if (method !== undefined && method !== '') {
            tempAttributes.method = method;
          }
          if (href !== undefined && href !== -1 && href !== '') {
            tempAttributes.href = href;
          }

          const tempButtonComponent = {
            type: 'button',
            components: label,
            attributes: tempAttributes,
            classes: ['btn', 'btn-primary','pointer']
          };
          // Store all the info of a button component
          tempComponents[index].components.push(tempButtonComponent);
        } else if (insideComp === 'label') {
          const {label} = componentsInfo[index].info[index2];
          const tempLabelComponent = { 
            type: 'label', 
            components: label,
            classes: ['col-form-label','margin-left']
          };
          tempComponents[index].components.push(tempLabelComponent);
        }
        // Check for component type textarea
        else if (insideComp === 'textarea') {
          const {placeholder} = componentsInfo[index].info[index2];
          const {required} = componentsInfo[index].info[index2];

          const tempTextareaComponent = {
            type: 'textarea',
            attributes: {
              placeholder,
              required
            },
            classes: ['form-control','margin-left']
          };
          // Store all the info of a textarea component
          tempComponents[index].components.push(tempTextareaComponent);
        }
        // Check for component type input
        else if (insideComp === 'input') {
          const {type} = componentsInfo[index].info[index2];
          const {placeholder} = componentsInfo[index].info[index2];

          const tempInputComponent = {
            type: 'input',
            attributes: { placeholder, type },
            classes: ['form-control','margin-left']
          };
          tempComponents[index].components.push(tempInputComponent);
        }
        // Check for component type dropdown
        else if (insideComp === 'dropdown') {
          const tempComponentsOptions = [];

          const {options} = componentsInfo[index].info[index2];
          options.forEach((option) => {
            tempComponentsOptions.push({
              tagName: 'li',
              components: [
                {
                  tagName: 'a',
                  type: 'link',
                  components: option,
                  classes: ['dropdown-item']
                }
              ]
            });
          });

          const {label} = componentsInfo[index].info[index2];
          const DropdownComponent = {
            tagName: 'div',
            attributes: { wablitype: 'dropdown' },
            classes: ['dropdown', 'dropdown-container','margin-left'],
            components: [
              {
                type: 'button',
                attributes: {
                  'aria-expanded': false,
                  'data-bs-toggle': 'dropdown',
                  id: 'dropdownMenuButton1-2',
                  wablitype: 'button',
                  wabliname: 'button'
                },
                classes: ['btn','btn-secondary', 'dropdown-toggle'],
                components: label
              },
              {
                tagName: 'ul',
                attributes: {
                  'aria-labelledby': 'dropdownMenuButton1'
                },
                classes: ['dropdown-menu'],
                components: tempComponentsOptions
              }
            ]
          };

          // Store all the info of a dropdown component
          tempComponents[index].components.push(DropdownComponent);
        }
        // Check for component type radio
        else if (insideComp === 'radio') {
          componentsInfo[index].info[index2].labels.forEach((label) => {
            const radioComponent = {
              tagName: 'div',
              attributes: { wablitype: 'radios' },
              classes: ['form-check', 'form-check-inline','margin-left'],
              components: [
                {
                  tagName: 'input',
                  type: 'radio',
                  attributes: { checked: true, value: label },
                  classes: ['form-check-input']
                },
                {
                  type: 'label',
                  classes: ['form-check-label'],
                  components: label
                }
              ]
            };
            // Store all the info of a radio component
            tempComponents[index].components.push(radioComponent);
          });
        }
        // Check for component type checkbox
        else if (insideComp === 'checkbox') {
          const {checked} = componentsInfo[index].info[index2];
          const tempCheckboxComponent = { type: 'radio', attributes: { checked }, classes: ['margin-left'] };

          // Store all the info of a checkbox component
          tempComponents[index].components.push(tempCheckboxComponent);
        }
      });
    });

    // In this var we store the info of the new, so we can reacreated it later
    const tempDataElementBlock = {
      id: producedBlockName,
      content: {
        components: tempComponents,
        type: 'form',
        tagName: 'form',
        attributes: {
          name: dataElementName
        }
      },
      label: `${producedBlockName  } Block`,
      category: {
        label: 'Extra ',
        open: 'false'
      }
    };
    /*
        If the edited form does not belong to a created data element but is a simple form  from the blocks then we create a
          data element with the name form and we connect the block there.
        */
    const tempDataElementInfo = {
      typeFields: [],
      dataName: 'form',
      components: [],
      data_element_components: [],
      type: 'form'
    };

    const indexDataEl = findIndexDataElement(selectedProject, dataElementName);
    const tempData = JSON.parse(localStorage.getItem('data'));
    if (tempData[selectedProject].data_elements.data_elements_blocks[indexDataEl] !== undefined) {
      tempData[selectedProject].data_elements.data_elements_blocks[indexDataEl].blocks.push(
        tempDataElementBlock
      );
    } else {
      tempData[selectedProject].data_elements.data_elements_blocks.push({
        blocks: [tempDataElementBlock]
      });
      tempData[selectedProject].data_elements.data_elements_info.push(tempDataElementInfo);
    }

    // Add the created block to BlockManager of the GrapesJs

    editor.BlockManager.add(producedBlockName, {
      label: `${producedBlockName  } Block`,
      content: {
        components: tempComponents,
        type: 'form',
        tagName: 'form',
        attributes: {
          name: dataElementName
        }
      },
      category: {
        label: 'Extra ',
        open: 'false'
      }
    });
    // Update the info of the created block to localStorage
    localStorage.setItem('data', JSON.stringify(tempData));
  }
}

export default extractContent;
